import { render, staticRenderFns } from "./StudentBenefitsVouchers.vue?vue&type=template&id=8afc5562"
import script from "./StudentBenefitsVouchers.vue?vue&type=script&lang=ts"
export * from "./StudentBenefitsVouchers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports